import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";

interface ICommercialOffer {
    id: number;
    main_image_url: string | null;
    name: string;
    region: {
        short_name: string;
    };
    groups: IOfferGroupsSimplified | null;
    slug: string;
    street_name: string | null;
    street_number: string | null;
    stats: {
        ranges_price_m2_min: number;
    } | null;
}

export interface VendorDetailCommercialsListItemProps {
    offer: ICommercialOffer;
    vendorSlug: string;
}

export const VendorDetailCommercialsListItem: React.FC<VendorDetailCommercialsListItemProps> = ({offer, vendorSlug}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerStreetNameWithNumber = offer.street_name ? `${offer.street_name} ${offer.street_number ? offer.street_number : ""}` : "";
    const offerAddress = `${offer.region.short_name}, ${offerStreetNameWithNumber}`;
    const priceM2Min = offer.stats?.ranges_price_m2_min || 0;

    return (
        <a href={offerLink} className={commercialOfferListItemStyle} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodyWithImage
                    image={<ResponsiveCard.ImgCover alt={offer.name} src={getThumbnailLink(offer.main_image_url, 155, 87) ?? ""} />}
                    header={offer.name}
                    headerTag="h3"
                    text={offerAddress}
                >
                    {priceM2Min > 0 && (
                        <Button variant="outlined_secondary" size="x-small" className={buttonStyle}>
                            od: {priceM2Min} zł/m2
                        </Button>
                    )}
                </ResponsiveCard.BodyWithImage>
            </ResponsiveCard>
        </a>
    );
};

const commercialOfferListItemStyle = css({
    display: "block",
    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "none"
    }
});

const buttonStyle = css({
    ml: 1,
    mr: 2,
    my: 2,
    px: 1,
    py: 0.5,
    height: "2.8rem",
    md: {
        my: 0
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";

interface ICommercialOffer {
    id: number;
    main_image_url: string | null;
    name: string;
    region: {
        short_name: string;
    };
    groups: IOfferGroupsSimplified | null;
    slug: string;
    street_name: string | null;
    street_number: string | null;
    stats: {
        ranges_price_m2_min: number;
    } | null;
}

export interface VendorDetailCommercialsListItemProps {
    offer: ICommercialOffer;
    vendorSlug: string;
}

export const VendorDetailCommercialsListItem: React.FC<VendorDetailCommercialsListItemProps> = ({offer, vendorSlug}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerStreetNameWithNumber = offer.street_name ? `${offer.street_name} ${offer.street_number ? offer.street_number : ""}` : "";
    const offerAddress = `${offer.region.short_name}, ${offerStreetNameWithNumber}`;
    const priceM2Min = offer.stats?.ranges_price_m2_min || 0;

    return (
        <a href={offerLink} className={commercialOfferListItemStyle} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodyWithImage
                    image={<ResponsiveCard.ImgCover alt={offer.name} src={getThumbnailLink(offer.main_image_url, 155, 87) ?? ""} />}
                    header={offer.name}
                    headerTag="h3"
                    text={offerAddress}
                >
                    {priceM2Min > 0 && (
                        <Button variant="outlined_secondary" size="x-small" className={buttonStyle}>
                            od: {priceM2Min} zł/m2
                        </Button>
                    )}
                </ResponsiveCard.BodyWithImage>
            </ResponsiveCard>
        </a>
    );
};

const commercialOfferListItemStyle = css({
    display: "block",
    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "none"
    }
});

const buttonStyle = css({
    ml: 1,
    mr: 2,
    my: 2,
    px: 1,
    py: 0.5,
    height: "2.8rem",
    md: {
        my: 0
    }
});
